import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ isMenuOpen, toggleMenu, closeMenu }) => {
  const navigate = useNavigate();

    const news = process.env.REACT_APP_NEWS
    const articles = process.env.REACT_APP_ARTICLES

  return (
    <header className="axl_fp_header">
      <div className="axl_fp_top-nav-logo-name cursor-pointer"
      onClick={() => navigate('/')}
      >
        <img
          src="/pimages/img_axl/nav-logo.png"
          alt="XTAL BALL Technologies"
          className="top-nav-logo"
        />

        <div 
          className="top-nav-name_v2 cursor-pointer"
          onClick={() => navigate('/')}
        >
          <div className="top-nav-name_v2__bold">XTAL BALL</div>
          <div className="top-nav-name_v2__ordinary">TECHNOLOGIES</div>
        </div>
      </div>
      
      <div 
        className={`axl_fp_menu-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <ul className={`axl_fp_nav-links ${isMenuOpen ? 'show' : ''}`}>
        <li><a href="/" onClick={closeMenu}>Home</a></li>
        {/* <li><a href="/products" onClick={closeMenu}>Products</a></li> */}
        <li><a href={news} onClick={closeMenu}>News</a></li>
        <li><a href={articles} onClick={closeMenu}>Articles</a></li>
        <li><a href="/about" onClick={closeMenu}>About</a></li>
      </ul>
    </header>
  );
};

export default Header;